import { useState } from 'react';

import { isEmpty } from '@npi/buddy-utils';
import { getMerchants, GetPartners } from 'types/graphql';

import { useQuery } from '@redwoodjs/web';

import { AutoCompleteOptionType } from 'src/components/FormikComponents/NPIAutoComplete';
import { GET_MERCHANTS } from 'src/graphql/queries/merchants.query';
import { GET_PARTNERS } from 'src/graphql/queries/partners.query';
import { onError } from 'src/utils/utils';

type UseMerchantsAndPartnersResponse = {
    partnerOptions: AutoCompleteOptionType[];
    merchantOptions: AutoCompleteOptionType[];
    merchantAccountNumberOptions: AutoCompleteOptionType[];
    partnersData: GetPartners;
    merchantsData: getMerchants;
};

function useMerchantsAndPartners(): UseMerchantsAndPartnersResponse {
    const [partnerOptions, setPartnerOptions] = useState<AutoCompleteOptionType[]>([]);
    const [merchantOptions, setMerchantOptions] = useState<AutoCompleteOptionType[]>([]);
    const [merchantAccountNumberOptions, setMerchantAccountNumberOptions] = useState<
        AutoCompleteOptionType[]
    >([]);

    const { data: partnersData } = useQuery(GET_PARTNERS, {
        onError,
        onCompleted: (data) => {
            const options = (data?.partners ?? [])
                .map(({ id, business }) => {
                    return {
                        id,
                        label: business?.legalName,
                        value: business?.legalName,
                    };
                })
                .filter(({ value }) => {
                    return !isEmpty(value);
                });
            setPartnerOptions(options);
        },
    });

    const { data: merchantsData } = useQuery(GET_MERCHANTS, {
        onError,
        onCompleted: (data) => {
            const options = (data?.merchants?.data ?? []).map(
                ({ id, merchantName, tradingName, merchantContactName }) => {
                    return {
                        id,
                        label: merchantName || tradingName || merchantContactName,
                        value: merchantName || tradingName || merchantContactName,
                    };
                }
            );

            const merchantAccountNumberOptions = (merchantsData?.merchants?.data ?? []).map(
                ({ id, merchantAccountNumber }) => {
                    return {
                        label: merchantAccountNumber,
                        value: id,
                    };
                }
            );
            setMerchantOptions(options);
            setMerchantAccountNumberOptions(merchantAccountNumberOptions);
        },
    });

    return {
        partnerOptions,
        merchantOptions,
        merchantAccountNumberOptions,
        partnersData,
        merchantsData,
    };
}

export default useMerchantsAndPartners;
